import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const DotsHorizontalCircleGlyph = /*#__PURE__*/createElement("g", {
  id: "more_vertical"
}, /*#__PURE__*/createElement("circle", {
  cx: "42",
  cy: "42",
  r: "27",
  fill: "none",
  strokeWidth: "4"
}), /*#__PURE__*/createElement("circle", {
  cx: "26",
  cy: "42",
  r: "3.7"
}), /*#__PURE__*/createElement("circle", {
  cx: "42",
  cy: "42",
  r: "3.7"
}), /*#__PURE__*/createElement("circle", {
  cx: "58",
  cy: "42",
  r: "3.7"
}));
const DotsHorizontalCircle = createSvg({
  name: 'dots_horizontal_circle',
  path: DotsHorizontalCircleGlyph
});

export default DotsHorizontalCircle;
export { DotsHorizontalCircleGlyph };
